import { Typography, RadioGroup, FormControlLabel, Radio } from '@vapor/material'
import { FormItem } from 'hic-components'
import { useTranslation } from 'react-i18next'
import { PropertyTypeBuyNow } from '../buy-now.type';

export default function StepOne({ propertyType, setPropertyType }: { propertyType: PropertyTypeBuyNow; setPropertyType: (type: PropertyTypeBuyNow) => void }) {
  const { t } = useTranslation()

  return (
    <>
      <Typography variant="body">{t('pms.buy_now.drawer.description')}</Typography>
      <FormItem fieldLabel={t('pms.buy_now.drawer.stepper_1.label')}>
        <RadioGroup
          onChange={(event) => {
            setPropertyType(event.target.value as PropertyTypeBuyNow  )
          }}
        >
          <FormControlLabel value="hotel" control={<Radio checked={propertyType === 'hotel'} />} label={t('pms.buy_now.drawer.stepper_1.hotel')} />
          <FormControlLabel value="appartment" control={<Radio checked={propertyType === 'appartment'} />} label={t('pms.buy_now.drawer.stepper_1.appartment')} />
        </RadioGroup>
      </FormItem>
    </>
  )
}
